"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'block',
        width: '100%',
        height: 'auto',
        fill: theme.indigo3,
        opacity: 0.6
    },
    icon: {
        flexShrink: 0,
        width: '70%',
        height: 'auto',
        maxWidth: 32,
        position: 'relative',
        color: theme.white1
    }
});
//# sourceMappingURL=avatar.group.overlay.style.js.map